export default __webpack_public_path__ + "static/media/breakfast-overlay-lyte@2x.9c78df03.png";